import { FEATURE_STATUS } from "features/Account/Account.constants";
import {
  KYC_TYPE,
  KYC_TYPE_OPTIONS,
  PAGE_SECTIONS_KEYS,
} from "../constants/OfferingPageSectionsKeys.constants";

export const getKYCTypeOptions = (sectionConfig) => {
  const isKRAInaccesible =
    sectionConfig?.[PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED]?.status ==
    FEATURE_STATUS.HIDDEN;

  return KYC_TYPE_OPTIONS.map((option) => ({
    ...option,
    disabled: option.value === KYC_TYPE.KRA && isKRAInaccesible,
  }));
};
